import ApiClient from '~/utils/ApiClient'
export default (ctx, inject) => {
  // used as $api, the $ is added by nuxt
  inject('api', new ApiClient(ctx))
}
